var exports = {
  "E": "ReposCountText__I2LZYX",
  "J": "ReposListContainer__20MJPz",
};

module.exports = exports;
